import buildFormData from "@utils/buildFormData";
import { PostJsonRequest, PostRequest } from "./http/BaseRequest";
import { BaseResponse } from "./http/responses/BaseResponse";
import W2UiFilterBuilder from "./w2ui";

interface IContractDataResponsed extends IContract {
  readonly files: string; //IContractFile[]
  readonly plans: string;
}
export interface IContractResponse extends BaseResponse {
  Total: number;
  Records: IContractDataResponsed[];
}

export class GetAllContracts extends PostRequest {
  constructor() {
    super(
      "/common/contracts/w2ui",
      new W2UiFilterBuilder()
        .setLimit(1499) // а потому что на беке 1500
        .setOffset(0)
        .build().stringParams
    );
  }
}
// export class GetContracts extends PostRequest {
//   constructor(offset = 0, limit = 20) {
//     const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
//     let params = builder.build().stringParams;
//     super("/common/contracts/w2ui", params);
//   }
// }

export interface IContractFile {
  readonly id: number;
  readonly name: string;
  readonly contractid: number;
  readonly path: string;
}

export interface IPlanInContract {
  readonly id: number;
  readonly name: string;
}

export interface IContract {
  readonly id: number;
  readonly name: string;
  readonly password: string;
  readonly usedbyminers: number;
  readonly usedbyusers: number;
  readonly meta: IContractMeta;
  readonly files: string; //IContractFile[] ;
  readonly plans: string; // JSON array ; {name, id}
  readonly user_id?: number;
}
export interface IContractMeta {
  readonly client?: number;
  readonly plan?: number;
  readonly text?: string;
  readonly consumption?: number;
}

export interface ICreateContractParams
  extends Omit<
    IContract,
    "meta" | "usedbyminers" | "usedbyusers" | "files" | "plans"
  > {
  readonly meta: string;
}

// export class CreateNewContract extends PostRequest {
//   constructor(data: ICreateContractParams) {
//     const builder = new W2UiFilterBuilder().setEdit({
//       recid: "new",
//       ...data,
//     });
//     let params = builder.build().stringParams;

//     super("/common/contracts/w2ui", params);
//   }
// }

export interface IEditContract extends Omit<ICreateContractParams, "id"> { }

// export class EditContract extends PostRequest {
//   constructor(id: number, data: IEditContract) {
//     const builder = new W2UiFilterBuilder().setEdit({
//       recid: id,
//       ...data,
//     });
//     let params = builder.build().stringParams;

//     super("/common/contracts/w2ui", params);
//   }
// }

export class DeleteContract extends PostRequest {
  constructor(id: number) {
    const builder = new W2UiFilterBuilder().setDelete(id);
    let params = builder.build().stringParams;

    super("/common/contracts/w2ui", params);
  }
}

// export class AddContractToMiners extends PostJsonRequest {
//   constructor(miner: string, contractid: number) {
//     super("/miner/settings/change", { id: [Number(miner)], contractid });
//   }
// }

export class DeleteContractFromMiners extends PostJsonRequest {
  constructor(miner: string) {
    super("/miner/settings/change", {
      id: [Number(miner)],
      removecontract: true,
    });
  }
}

export class RemovePlanFromMiner extends PostJsonRequest {
  constructor(miner: string) {
    super("/miner/settings/change", {
      id: [Number(miner)],
      removeplan: true,
    });
  }
}

export class AddContractToUser extends PostJsonRequest {
  constructor(userId: number, id: string) {
    super("/common/contracts/update", { userId, id });
  }
}

export class DeleteContractFromUser extends PostRequest {
  constructor(userid: number, contracts: number[]) {
    const builder = new W2UiFilterBuilder().setDelete(...contracts);
    let params = builder.build().stringParams;
    params += (params.length ? "&" : "") + `userid=${userid}`;
    super("/admin/user/contract/delete", params);
  }
}

export interface IUploadFilesResponse extends BaseResponse {
  Record: IContractFile;
}

export class UploadContractFile extends PostRequest {
  constructor(id: number, file: Blob) {
    const data = buildFormData({ id, file });
    super("/admin/contracts/uploadfile", data);
  }
}

export class DeleteContractFile extends PostRequest {
  constructor(id: string[]) {
    super("/admin/contracts/deletefile", { id: id.join(",") });
  }
}

// export class AddNewPlansToContract extends PostRequest {
//   constructor(contract_id: number, plans: (string | number)[]) {
//     super("/admin/contracts/assign_plan", {
//       contract_id,
//       plan_id: plans.join(","),
//     });
//   }
// }

export interface ContractParam {
  id: number;
  userId: number;
  name?: string;
  password: string;
  planId: number[];
  meta: string;
}

export type AddContractParams = Omit<ContractParam, "planId" | "id"> & {
  planId: number;
};

export interface AddContractResult {
  id: number;
  name: string;
  password: string;
  meta: string;
  planId: number;
  userId: number;
}
export class CreateContract extends PostJsonRequest {
  constructor(value: AddContractParams) {
    super("/common/contracts/add", value);
  }
}
export class UpdateContract extends PostJsonRequest {
  constructor(value: ContractParam) {
    super("/common/contracts/update", value);
  }
}
